<script type="text/jsx" lang="jsx">
import { createEditDeltaComponent } from '@/components/edit-delta-factory';
import commonMixin from '@/plans/VISITOR_MANAGEMENT/mixin';
import { planTypes } from '@/common/constants';

export default createEditDeltaComponent({
  name: 'VisitorManagementEditDelta',
  planType: planTypes.VISITOR_MANAGEMENT,
  mixin: commonMixin,
});
</script>

<style lang="scss">
.opc-zwb {
  &__preview-payment {
    margin-top: 24px;
  }
}
</style>
